module.exports = __webpack_public_path__ + "img/nav-design-collectionrings@2x.b4d29c2.jpg";